module.exports = __webpack_public_path__ + "static/media/follow_icon.88de6ffd.svg";